import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import Input from "components/form/input/Input";
import TextField from "components/form/textField/TextField";

import "./customerCreditAdjustModal.scss";

type CustomerCreditAdjustModalProps = {
  open: boolean;
  onClose: () => void;
  onOk: (amount: string, note: string) => Promise<void>;
};

export default function CustomerCreditAdjustModal(props: CustomerCreditAdjustModalProps) {
  const { open, onClose, onOk } = props;
  const { t } = useTranslation();

  const [amount, setAmount] = useState<string>("");
  const [note, setNote] = useState<string>("");

  useEffect(() => {
    if (!open) {
      setAmount("");
      setNote("");
    }
  }, [open]);

  function handleOnClose() {
    setAmount("");
    setNote("");
    onClose();
  }

  const okDisabled = amount === "" || isNaN(Number(amount));

  return (
    <div className="customer-credit-adjust-sheet">
      <Sheet
        open={open}
        title={t("Adjust credit book balance")}
        onCancel={handleOnClose}
        onOk={() => onOk(amount, note)}
        okDisabled={okDisabled}
        okText={t("Save and apply")}
        cancelText={t("Cancel")}
        size="x-small"
        height="flexible"
        overflow
        closable
      >
        <Form>
          <FormLayout>
            <FormLayout.Group>
              <Input
                label={t("Amount")}
                type="text"
                id="amount"
                prefix="$"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                helpText={t("Enter an amount to update the current balance")}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label={t("Reason (Optional)")}
                id="note"
                value={note}
                placeholder={t("Add a note for your records...")}
                rows={4}
                noResize
                onChange={e => setNote(e.target.value)}
              />
            </FormLayout.Group>
          </FormLayout>
        </Form>
      </Sheet>
    </div>
  );
}
